import React, { useEffect, useState } from "react";
import styles from "./PreviewStopwatch.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import {
  Box,
  Button,
  Select,
  MenuItem,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";
import { setSelectedOptionsForFormula } from "redux/slices/scoringSlice";
import { useDispatch } from "react-redux";

const PreviewStopwatch = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const dispatch = useDispatch();
  // const [typeoff , setTypeoff] = useState(props?.data?.typeof || "stopwatch")
  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [isPaused, setIsPaused] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [selectedTime, setSelectedTime] = useState(""); // New state for displaying saved time
  const formatTime = (time) => {
    const getSeconds = `0${time % 60}`.slice(-2);
    const minutes = Math.floor(time / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(time / 3600)}`.slice(-2);

    return `${getHours}:${getMinutes}:${getSeconds}`;
  };

  const handleButtonClick = () => {
    if (!isActive && isPaused) {
      setIsActive(true);
      setIsPaused(false);
    } else if (isActive && !isPaused) {
      setIsActive(false);
      setIsPaused(false);
    } else if (!isActive && !isPaused) {
      setTime(0);
      setIsPaused(true);
    }
  };

  const getButtonLabel = () => {
    if (!isActive && isPaused) {
      return "Start";
    } else if (isActive && !isPaused) {
      return "Stop";
    } else if (!isActive && !isPaused) {
      return "Reset";
    }
  };

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setTime((time) => time + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive]);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleSelectChange = (type, value) => {
    if (type === "hours") setHours(value);
    if (type === "minutes") setMinutes(value);
    if (type === "seconds") setSeconds(value);
  };

  const handleSaveTime = () => {
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    setSelectedTime(formattedTime);
    // console.log("formattedTime", formattedTime);
    dispatch(
      setSelectedOptionsForFormula({ id: props.id || props?._id, value: formattedTime })
    );

    setModalOpen(false);
  };
  // useEffect(() => {
  //   dispatch(setSelectedOptionsForFormula({ id: props.id, value: "00:00:00" }));
  // }, []);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.mainContent}>
          <div className={styles.heading}>
            <span>
              {props?.data?.required && <span style={{ color: "red" }}>*</span>}
              {props?.data?.value || props?.name || props?.label}
            </span>
            {props?.instructions || props?.data?.media?.length ? (
              <div>
                {showIcon ? (
                  <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
                ) : (
                  <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
                )}
              </div>
            ) : null}
          </div>

          <div className={styles.rightContainer}>
            {  props?.typeOfStopwatch === "stopWatch" ? ( //props?.data?.typeOfStopwatch  add later when done by other side 
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "165px",
                }}
              >
                <div className={styles.timer}>
                  <span>{formatTime(time)}</span>
                </div>
                <div onClick={handleButtonClick}>
                  <Button variant="contained">{getButtonLabel()}</Button>
                </div>
              </div>
            ) : (
              <Button variant="outlined" onClick={handleModalOpen}>
                {selectedTime || "Set Time"}
              </Button>
            )}
          </div>
        </div>
        {showIcon && (
          <div className={styles.subContent}>
            {props?.instructions && (
              <div className={styles.instructionText}>
                {props?.instructions}
              </div>
            )}
            {props?.data?.media?.length ? (
              <>
                {props?.data?.media.map((image) => (
                  <img
                    className={styles.imageStyle}
                    src={image.path}
                    alt="Preview"
                  />
                ))}
              </>
            ) : null}
          </div>
        )}

        {/* Modal for Time Selection */}
      </div>

      <Box
        className={styles.modalContainer}
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          transform: modalOpen ? "translate(0, 0)" : "translate(0, 250px)",
          transition: "transform 0.3s ease-in-out", // Smooth transition
          bgcolor: "background.paper",
          p: 3,
          boxShadow: 24,
          borderRadius: "16px 16px 0 0",
          zIndex: 10,
          backgroundColor: "white",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Set Time
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-around", mb: 2 }}>
          <FormControl sx={{ minWidth: 80, marginTop: 1 }}>
            <InputLabel>Hours</InputLabel>
            <Select
              value={hours}
              onChange={(e) => handleSelectChange("hours", e.target.value)}
              sx={{ marginTop: 1 }} // Adjusts the space for the select dropdown
            >
              {[...Array(24).keys()].map((num) => (
                <MenuItem key={num} value={num}>
                  {num.toString().padStart(2, "0")}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 80, marginTop: 1 }}>
            <InputLabel>Minutes</InputLabel>
            <Select
              value={minutes}
              onChange={(e) => handleSelectChange("minutes", e.target.value)}
              sx={{ marginTop: 1 }}
            >
              {[...Array(60).keys()].map((num) => (
                <MenuItem key={num} value={num}>
                  {num.toString().padStart(2, "0")}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 80, marginTop: 1 }}>
            <InputLabel>Seconds</InputLabel>
            <Select
              value={seconds}
              onChange={(e) => handleSelectChange("seconds", e.target.value)}
              sx={{ marginTop: 1 }}
            >
              {[...Array(60).keys()].map((num) => (
                <MenuItem key={num} value={num}>
                  {num.toString().padStart(2, "0")}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          variant="contained"
          onClick={handleSaveTime}
          fullWidth
          sx={{ borderRadius: "8px" }}
        >
          Save Time
        </Button>
      </Box>
    </>
  );
};

export default PreviewStopwatch;
